import { observable, makeObservable } from 'mobx';
import { useStores } from '../useStores';
import withActions from '../withActions';
import actions from './actions';

export default class SubscriptionsStore {
    version = '1.0';

    subscriptions = [];
    inactiveSubscriptions = [];
    unsubscribeList = [];

    fetchedSchedules = {};
    isLoadingCard = {};
    unsubscribeProgress = {};

    connectedSchedules = {};    // { [subscriptionId]: Schedule[] } — built on getSubscriptions
    subscriptionDetails = {};   // { [subscriptionId]: flat display fields } — built on getSubscriptions

    availableSchedules = {};
    availableSchedulesLoaded = {};
    availableSchedulesExpanded = {};
    subscriptionsExpanded = {};

    // Per-card signal — ObservableMap tracks reads at key level so only the
    // affected SubscriptionCardContainer re-renders on add/remove schedule
    cardSignals = observable.map({});

    page = { number: 1, limit: 10 };

    loadProgress = {
        subscriptions: true,
        messageStep: 0,
        message: 'Loading',
        dots: '.',
        dotsCount: 0,
        progressLabel: 'Loading',
    };

    observed = {};

    constructor() {
        makeObservable(this, { observed: observable });
        withActions(this, actions);
    }
}

export function useSubscriptionsStore() {
    const { store } = useStores();
    return store.subscriptionsStore;
}
